export default __webpack_public_path__ + "static/media/1415 utensils side.d7630013.png";